import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { entitySelectors } from '@store/entity/selectors';

import { SpaTreatmentsV2 } from './SpaTreatmentsV2';
import {
  SpaTreatmentsV2DispatchProps,
  SpaTreatmentsV2OwnProps,
  SpaTreatmentsV2StoreProps,
} from './SpaTreatmentsV2.types';

const mapStateToProps = (state): SpaTreatmentsV2StoreProps => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch): SpaTreatmentsV2DispatchProps =>
  bindActionCreators({ changeJourneyParam }, dispatch);

export const SpaTreatmentsV2Connected: React.ComponentType<SpaTreatmentsV2OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaTreatmentsV2);
